import { FCM_NAVIGATE_KEY } from "./enum";

export const QK = {
  chat: (chatId: string) => [FCM_NAVIGATE_KEY.chat, chatId] as const,
  chats: [FCM_NAVIGATE_KEY.chats],
  dateRecruitment: [FCM_NAVIGATE_KEY.dateRecruitment],
  plans: [FCM_NAVIGATE_KEY.plans],
  rejectList: (uid: string, isFemaleUser: boolean) =>
    ["rejectList", uid, isFemaleUser] as const,
  subscriptionOrder: (uid: string) => ["subscriptionOrder", uid],
  subscriptionMember: () => ["subscriptionMember"],
  fancloveMembers: (uid: string) => ["fancloveMembers", uid],
  subscriptionOrderId: (orderId: string) => ["subscriptionOrder", orderId],
  wallets: (search: string) => ["wallets", search],
  walletByIds: (ids: string[]) => ["wallets", ids]
};
